
angular.module('bmsApp.directives')
	.directive('riskAssessmentResponseView', [
		function () {
			return {
				restrict: 'E',
				scope: {
					riskAssessmentResponses: '=',
				},
				replace: true,
				templateUrl: 'ng/global/visit-risk-assessment-response/templates/RiskAssessmentResponseView.html',
				link: function (scope, element, attrs) {
				},
				controller: function ($scope) {
				}
			};
		}]);
